"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.flushEvents = exports.record = exports.updateEndpoint = void 0;
var updateEndpoint_1 = require("./updateEndpoint");
Object.defineProperty(exports, "updateEndpoint", { enumerable: true, get: function () { return updateEndpoint_1.updateEndpoint; } });
var record_1 = require("./record");
Object.defineProperty(exports, "record", { enumerable: true, get: function () { return record_1.record; } });
var flushEvents_1 = require("./flushEvents");
Object.defineProperty(exports, "flushEvents", { enumerable: true, get: function () { return flushEvents_1.flushEvents; } });
